import { action as apiAction } from 'api/Api'
import requestAddLabel from './requestAddLabel'

type Payload = {
  cardId: number
  name: string
  color: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { cardId, name, color } = payload

  const state = getState()

  const boardId = state['view-board'].cards[cardId].boardId

  const Label = await apiAction('AddLabel', {
    boardId,
    name: name.trim(),
    color
  })

  await dispatch(requestAddLabel({
    cardId,
    labelId: Label.Id
  }))
}
